module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-paytable-selected@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-betmenu/btn-paytable-selected@3x.png
// module id = 637
// module chunks = 0